import ReservedExamDTO from "../DTO/reservedExamDTO.js"
import WsInternal from "@/services/api/util/websocket-internal"
import {convertToDefaultDateHourFormat} from "@/util"

export default class CandidateDisabled extends WsInternal {
  constructor(disabledModel, token) {
    super(process.env.VUE_APP_CRM_WS + `candidates_broadcast?auth_token=${token}`)
    this.disabledModel = disabledModel
  }

  startListen(getListCallback, callback) {
    this.ws.onmessage = event => {
      const wsMessageData = this.getMsgData(event)
      if(!wsMessageData) return
      this.setCandidateData(wsMessageData, getListCallback(), callback)
      // if(callback) callback(wsMessageData)
    }
  }

  setCandidateData(candidate, list, callback) {
    let item = list.find(item => item.ID === candidate.id)
    if(!item) return
    for(let field in candidate) {
      if(field === 'reserved_exam') {
        this.setReservedExam(item, candidate.reserved_exam)
        continue
      }
      if(!item._apiAttributes[field]) continue
      item[item._apiAttributes[field]] = candidate[field]
    }
    if(this.disabledModel) this.disabledModel.checkCBRStatus(item.status)
    this._setAnimation(item)
    if(callback) callback(candidate, item)
  }

  setReservedExam(item, reservedExam) {
    if(!reservedExam) {
      for(let field in item.reservedExam) {
        item.reservedExam[field] = null
      }
      return
    }
    if(reservedExam.location) item.reservedExam.location = reservedExam.location
    if(reservedExam.datetime) item.reservedExam.examDate = convertToDefaultDateHourFormat(reservedExam.datetime)
    if(reservedExam.reservation_code) item.reservedExam.code = reservedExam.reservation_code
  }

  _setAnimation(item) {
    item.animation = true
    setTimeout(() => {
      item.animation = false
    }, 1000);
  }

  close() {
    this.ws.close()
  }


}